import {css, styled} from '@mui/material';
import {StyledCard} from 'presentation/components';

interface AppointmentDetailsCardContainerProps {
	$fixPosition?: boolean;
}
export const AppointmentDetailsCardContainer = styled(
	StyledCard.Container,
)<AppointmentDetailsCardContainerProps>`
	border-radius: 8px;

	${({theme}) => theme.breakpoints.down('md')} {
		border-radius: 0;
	}

	&.MuiPaper-root {
		${({$fixPosition}) =>
			$fixPosition &&
			css`
				position: fixed;
				bottom: 0;
				left: 0;
				right: 0;
				padding: 16px 8px;
				margin: 0;
				background: ${({theme}) => theme.palette.primary.contrastText};
				z-index: 10;
			`}
	}
`;
